var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRandom9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:#fff;font-family:SegoeUI, Segoe UI;}.a{font-size:4px;}.b{fill:#904f89;}.c{fill:#ad5cad;}.d{fill:#c1b5d2;}.e{font-size:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72 -598)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(80 610)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(80 629)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(96 629)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 867) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 218)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 50,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H50V17H0Z",
    transform: "translate(0 17.515)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 50,
    height: 17,
    transform: "translate(0 34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(35 41) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")))), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(79 623.744)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(79 641.256)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(92 641.256)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(94 623.744)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom9);
export default __webpack_public_path__ + "static/media/random9.d705bfd45c74c3881888ad0087b53570.svg";
export { ForwardRef as ReactComponent };